import React from 'react';
import { Runtime } from '@hud/portal-dtos/webapp-common.dto';
import { HudIcon } from '../Icons/HudIcons';
import Tooltip from '../Tooltip/Tooltip';
import { runtimeToDisplay, runtimeToIcon } from './common';

export interface RuntimeIconProps {
  runtime: Runtime;
  className?: string;
}

export const RuntimeIcon: React.FC<RuntimeIconProps> = ({
  runtime,
  className,
}) => {
  return (
    <Tooltip className={className} description={runtimeToDisplay[runtime]}>
      <HudIcon icon={runtimeToIcon[runtime]} size="16px" />
    </Tooltip>
  );
};
